import CloudUtils from '../../utils/CloudUtils'

class AppLinkService {
  async list (position = 1) {
    var result = null;
    try {
      result = await CloudUtils.post('/shuimujiaju-customer-api/app/link/list', { position })
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
  async get (id) {
    var result = null;
    try {
      result = await CloudUtils.post('/shuimujiaju-customer-api/app/link/get', {linkId: id})
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new AppLinkService()
